var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsufficientPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 138,
    viewBox: "0 0 228 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_407_4039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.1399 19.4C47.7599 19.4 49.0799 18.08 49.0799 16.46C49.0799 14.84 47.7599 13.52 46.1399 13.52C44.5199 13.52 43.2 14.84 43.2 16.46C43.2 18.08 44.5199 19.4 46.1399 19.4Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.2498 19.4C61.8698 19.4 63.1898 18.08 63.1898 16.46C63.1898 14.84 61.8698 13.52 60.2498 13.52C58.6298 13.52 57.3098 14.84 57.3098 16.46C57.3098 18.08 58.6298 19.4 60.2498 19.4Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.2798 19.4C75.8998 19.4 77.2198 18.08 77.2198 16.46C77.2198 14.84 75.8998 13.52 74.2798 13.52C72.6598 13.52 71.3398 14.84 71.3398 16.46C71.3398 18.08 72.6598 19.4 74.2798 19.4Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M134.15 125.98H41.8099C37.6899 125.98 34.3499 122.64 34.3499 118.52V10.1202C34.3499 6.00016 37.6899 2.66016 41.8099 2.66016H186.89C191.01 2.66016 194.35 6.00016 194.35 10.1202V16.1602",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M149.57 57.7803H50.67C46.55 57.7803 43.21 54.4403 43.21 50.3203V38.5303C43.21 34.4103 46.55 31.0703 50.67 31.0703H186.88C191 31.0703 194.34 34.4103 194.34 38.5303V57.7803",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M101.23 16.46H176.34",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M225.61 69.1504L215.76 79.0104",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M225.61 79.0104L215.76 69.1504",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.29989 54.2502C10.0116 54.2502 12.2099 52.0519 12.2099 49.3402C12.2099 46.6285 10.0116 44.4302 7.29989 44.4302C4.58817 44.4302 2.38989 46.6285 2.38989 49.3402C2.38989 52.0519 4.58817 54.2502 7.29989 54.2502Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M50.3099 113.65C46.3899 113.65 43.2 110.47 43.2 106.54V76.9C43.2 72.98 46.3799 69.79 50.3099 69.79H74.4499C78.3699 69.79 81.5599 72.97 81.5599 76.9",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M102.9 113.65C98.9798 113.65 95.7898 110.47 95.7898 106.54V76.9C95.7898 72.98 98.9698 69.79 102.9 69.79H127.04C130.96 69.79 134.15 72.97 134.15 76.9",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M162.78 83.0703C162.78 76.1303 168.4 70.5003 175.34 70.5103C182.28 70.5103 187.9 76.1303 187.9 83.0703V89.6903",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M154.43 83.0799C154.43 71.5399 163.8 62.1699 175.34 62.1699C186.89 62.1699 196.25 71.5299 196.25 83.0799V92.4299C196.25 93.2199 196.89 93.8599 197.68 93.8599C203.54 93.8599 208.28 98.6099 208.28 104.46V124.75C208.28 130.61 203.53 135.35 197.68 135.35H153.02C147.16 135.35 142.42 130.6 142.42 124.75V104.46C142.42 98.5999 147.17 93.8599 153.02 93.8599H175.91C178.8 93.8599 181.14 96.1999 181.14 99.0899V114.39C181.14 115.95 179.87 117.22 178.31 117.22H174.93C173.13 117.22 171.67 115.76 171.67 113.96V107.26",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_4039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227.22,
    height: 137.68,
    fill: "white",
    transform: "translate(0.389893 0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsufficientPermission);
export default __webpack_public_path__ + "static/media/insufficient-permission.e162b30d9421914823a48b6c2584fa74.svg";
export { ForwardRef as ReactComponent };